/* ============================================================
   Ker Sun - Carrousel vignettes produits (page collection)
   ------------------------------------------------------------
   À ajouter dans : assets/component-card-carousel.js
   Puis l'inclure dans theme.liquid avant la balise </body> :
   <script src="{{ 'component-card-carousel.js' | asset_url }}" defer></script>
   ============================================================ */

(function() {
  'use strict';

  // Configuration
  const SELECTORS = {
    carousel: '[data-ks-carousel]',
    track: '[data-ks-track]',
    slide: '[data-ks-slide]',
    prev: '[data-ks-prev]',
    next: '[data-ks-next]',
    progress: '[data-ks-progress]',
    progressSegment: '[data-ks-progress-segment]'
  };

  /**
   * Initialise un carrousel de vignette
   * @param {HTMLElement} carousel
   */
  function initCarousel(carousel) {
    // Évite la double initialisation
    if (carousel.dataset.ksCarouselInitialized === 'true') return;
    carousel.dataset.ksCarouselInitialized = 'true';

    const track = carousel.querySelector(SELECTORS.track);
    const slides = carousel.querySelectorAll(SELECTORS.slide);
    const prevBtn = carousel.querySelector(SELECTORS.prev);
    const nextBtn = carousel.querySelector(SELECTORS.next);
    const segments = carousel.querySelectorAll(SELECTORS.progressSegment);

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    const slideCount = slides.length;

    /**
     * Met à jour l'index courant et l'UI (barre + flèches)
     */
    function updateState(newIndex) {
      currentIndex = Math.max(0, Math.min(newIndex, slideCount - 1));

      // Mise à jour de la barre de progression
      segments.forEach((segment, i) => {
        segment.classList.toggle('is-active', i === currentIndex);
      });

      // Mise à jour de l'état des flèches
      if (prevBtn) {
        prevBtn.disabled = currentIndex === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = currentIndex === slideCount - 1;
      }

      // Mise à jour du tabindex pour l'accessibilité clavier
      slides.forEach((slide, i) => {
        const link = slide.querySelector('a');
        if (link) {
          link.setAttribute('tabindex', i === currentIndex ? '0' : '-1');
        }
      });
    }

    /**
     * Fait défiler vers un slide spécifique
     */
    function goToSlide(index) {
      const targetIndex = Math.max(0, Math.min(index, slideCount - 1));
      const targetSlide = slides[targetIndex];
      if (!targetSlide) return;

      track.scrollTo({
        left: targetSlide.offsetLeft,
        behavior: 'smooth'
      });
    }

    /**
     * Détecte le slide actif via le scroll position
     * Utilise IntersectionObserver pour de meilleures performances
     */
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            const slide = entry.target;
            const index = parseInt(slide.dataset.ksIndex, 10);
            if (!isNaN(index)) {
              updateState(index);
            }
          }
        });
      },
      {
        root: track,
        threshold: [0.6]
      }
    );

    slides.forEach((slide) => observer.observe(slide));

    // Gestion des flèches (desktop)
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex + 1);
      });
    }

    // Empêche le drag de l'image native d'interférer avec le swipe
    slides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (img) {
        img.addEventListener('dragstart', (e) => e.preventDefault());
      }
    });

    // État initial
    updateState(0);
  }

  /**
   * Initialise tous les carrousels présents dans le DOM
   */
  function initAllCarousels(root = document) {
    const carousels = root.querySelectorAll(SELECTORS.carousel);
    carousels.forEach(initCarousel);
  }

  /**
   * Observe les ajouts de nouveaux carrousels (pagination AJAX, filtres, etc.)
   * Utile pour les pages collection avec "Load more" ou filtres dynamiques
   */
  function observeNewCarousels() {
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return; // Element nodes only
          if (node.matches && node.matches(SELECTORS.carousel)) {
            initCarousel(node);
          } else if (node.querySelectorAll) {
            initAllCarousels(node);
          }
        });
      });
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialisation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllCarousels();
      observeNewCarousels();
    });
  } else {
    initAllCarousels();
    observeNewCarousels();
  }

  // Expose une API publique pour ré-initialisation manuelle si besoin
  // (utile en cas de filtres collection avec rechargement AJAX du thème Concept)
  window.KsCardCarousel = {
    init: initAllCarousels,
    initOne: initCarousel
  };
})();